/**
 * Waitlist API
 * HTTP API calls for waitlist functionality (matches backend POST /api/waitlist).
 */

import apiClient from '../../../../shared/lib/apiClient';

export interface WaitlistRequest {
  email: string;
}

/** Backend returns { status, message?, data? }; success when status === 'success' */
export interface WaitlistResponse {
  status: string;
  message?: string;
  data?: {
    id: string;
    email: string;
    status: string;
    created_at: string;
    updated_at?: string;
  };
}

/**
 * Submit email to waitlist.
 * Resolves with the full response; throws on network or 4xx/5xx (e.g. 409 duplicate).
 */
export async function submitToWaitlist(email: string): Promise<WaitlistResponse> {
  return apiClient<WaitlistResponse>('/waitlist', {
    method: 'POST',
    body: { email: email.trim() },
    requireAuth: false,
  });
}
